<template>
  <div
    v-show="visible"
    class="m-popup-comments-rules"
  >
    <div class="comments-title">
      Rules of Comments :
    </div>

    <div class="comments-content">
      <div class="comments-images">
        <div class="comments-images-item">
          <p>1. You can express your opinions on MSport, but any form of advertisement is not allowed.</p>
          <img
            src="../images/comments-rules-1.png"
            alt=""
          >
        </div>
        <div class="comments-images-item">
          <p>2. To protect your privacy, do not post any personal information, including real names, mobile phone numbers, or whatsapp numbers, etc.</p>
          <img
            src="../images/comments-rules-2.png"
            alt=""
          >
        </div>
        <div class="comments-images-item">
          <p>3. Any form of violence, abuse or pornography is prohibited.</p>
          <img
            src="../images/comments-rules-3.png"
            alt=""
          >
        </div>
      </div>

      <div class="comments-rules">
        <h4>Enforcement</h4>
        <p>We have a variety of ways of enforcing our rules, including but not limited to :</p>
        <p>Asking you nicely to knock the related comments off;</p>
        <p>Suspending related accounts temporarily or permanently;</p>
        <p>Removing privileges from related accounts;</p>
        <p>Adding restrictions to related accounts;</p>
        <p>Removing related contents.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'crypto-fetch/axios'
import toast from 'fe-vui/toast'

export default {
  name: 'CommentsRules',
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      nickname: null,
      inputStatus: 'default',
      errorText: ''
    }
  },
  methods: {
    async setNickname() {
      try {
        await axios.put(`/gossip/comments/nickName/set?nickName=${this.nickname}`)
        toast('Nickname set successfully !')
        this.$emit('onSuccess')
      } catch (error) {
        const { message } = error
        if (error.bizCode) {
          this.inputStatus = 'error'
          this.errorText = message
        } else {
          toast(message)
        }
      }
    },
    onInput(val) {
      if (val.length > 15) {
        this.nickname = val.slice(0, 15)
        this.inputStatus = 'error'
        this.errorText = 'Nickname, enter up to 15 characters.'
      } else {
        this.nickname = val.slice(0, 15)
        this.inputStatus = 'default'
        this.errorText = ''
      }
    },
    cancle() {
      // 存local
      this.$emit('onClose')
    },
    ok() {
      if (this.nickname) {
        this.setNickname()
      }
    }
  }
}
</script>
<style lang="less">
@import url("~wap/common/style/variable.less");

.m-popup-comments-rules {
  width: 100%;
  padding: 30px 0 35px;
  border-radius: 4px;
  background: #f8f8f8;

  .comments-title {
    width: 220/280 * 100%;
    margin: 0 auto;
    color: @major;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
  }

  .comments-content {
    width: 100%;
    max-height: 302px;
    padding-top: 20px;
    overflow-y: scroll;
  }

  .comments-images {
    width: 220/280 * 100%;
    margin: 0 auto;
    margin-bottom: 10px;
    text-align: left;

    &-item {
      padding-bottom: 20px;

      p {
        margin-bottom: 4px;
        color: @major;
        font-size: 12px;
        line-height: 14px;
      }

      img {
        width: 100%;
      }
    }
  }

  .comments-rules {
    width: 220/280 * 100%;
    margin: 0 auto;
    text-align: left;

    & > h4 {
      margin-bottom: 10px;
      color: @major;
      font-size: 14px;
      line-height: 16px;
    }

    & > p {
      position: relative;
      margin-top: 6px;
      color: @normal;
      font-size: 12px;
      line-height: 14px;
      text-indent: 6px;
    }

    & > p:nth-child(2) {
      margin-bottom: 25px;
      margin-left: 0;
      text-indent: 0;
    }

    & > p:not(:nth-child(2))::before {
      position: absolute;
      top: 5px;
      left: 0;
      width: 2px;
      height: 2px;
      border-radius: 50%;
      background: @normal;
      content: "";
    }
  }
}
</style>
